import { NgModule, ModuleWithProviders } from '@angular/core';
import * as resolvers from 'resolvers';

@NgModule()
export class ResolversModule {
	static forRoot(): ModuleWithProviders<ResolversModule> {
		return {
			ngModule: ResolversModule,
			providers: [
				resolvers.ClientResolver,
				resolvers.SuperhogResolver,
				resolvers.UserResolver,
				resolvers.CountriesResolver,
				resolvers.AccommodationsResolver,
				resolvers.TripsResolver,
				resolvers.OneStepLinkResolver,
			],
		};
	}
}
